import { render, staticRenderFns } from "./MissionRewardTable.vue?vue&type=template&id=b0a8380a&scoped=true&"
import script from "./MissionRewardTable.vue?vue&type=script&lang=js&"
export * from "./MissionRewardTable.vue?vue&type=script&lang=js&"
import style0 from "./MissionRewardTable.vue?vue&type=style&index=0&id=b0a8380a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a8380a",
  null
  
)

export default component.exports